import React from 'react';
import { BetResponseCode, isMobile, notificationStore } from '@pascal/pascal-core';
import { betInputPlusOrMinus, globalTranslationKeys, numPadTypes } from '../../../../enums';

export const AutoCashOutSection = ({
  handleAutoCashOutOdd,
  onChangeAutoCashOut,
  handleOpenNumPad,
  autoCashOutOdd,
  handleSwitcher,
  isAutoCashOut,
  inputDisable,
  params,
  onBlur,
  index,
  t,
}) => {
  const { AutoCashOut } = globalTranslationKeys;
  return (
    <div className='bet-sec-row row-3'>
      <div className='autocashout-row'>
        <div className='autocash-bl'>
          <p className='mid-text' title={t(AutoCashOut)}>
            {t(AutoCashOut)}
          </p>
          <div
            className={`inner-switch-body  ${isAutoCashOut ? 'active' : ''}`}
            onClick={handleSwitcher}
          >
            <span className='switch' />
          </div>
        </div>
        <div className={`bet-inpt-box  mid ${!isAutoCashOut ? 'disabled' : ''}`}>
          <div className='bet-inpt-box-inner'>
            <div
              className='bet-inpt-rulers'
              onClick={() => {
                if (autoCashOutOdd <= params.minValue) {
                  notificationStore.setNotificationType({
                    responseCode: BetResponseCode.InValidAutoCashOutOdd,
                  });
                }
                handleAutoCashOutOdd(betInputPlusOrMinus.minus, index);
              }}
            >
              <span className='ui-lib-minus' />
            </div>
            <input
              disabled={inputDisable}
              className='bet-opt-inp'
              type='text'
              maxLength='9'
              inputMode='none'
              value={autoCashOutOdd}
              onChange={onChangeAutoCashOut}
              onBlur={onBlur}
              onPaste={(e) => {
                e.preventDefault();
              }}
              {...(isMobile()
                ? { onClick: (e) => handleOpenNumPad(e, numPadTypes.manualCashOut, index, params) }
                : {})}
            />
            <div
              className='bet-inpt-rulers'
              onClick={() => {
                if (autoCashOutOdd >= params.maxValue) {
                  notificationStore.setNotificationType({
                    responseCode: BetResponseCode.InValidMaxAutoCashOutOdd,
                  });
                }
                handleAutoCashOutOdd(betInputPlusOrMinus.plus, index);
              }}
            >
              <span className=' ui-lib-plus' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
